export enum FilterTypes {
    TEXT_FILTER = 'textFilter',
    BOOLEAN_FILTER = 'booleanFilter',
    TEXT_EQUAL_FILTER = 'textEqualFilter',
}
